// Shared status constants for vendor quotes.
// Used by BOQQuotesTab, TradeQuotesModal, QuoteFormModal, QuoteComparisonModal, VendorsPage, QuoteRow.

export const STATUS_LABELS = {
  draft: 'טיוטה',
  sent_to_vendor: 'נשלח לספק',
  vendor_clarification: 'בירור',
  quote_received: 'התקבלה הצעה',
  selected: 'נבחר',
  rejected: 'נדחה',
};

export const STATUS_CLASSES = {
  draft: 'draft',
  sent_to_vendor: 'sent',
  vendor_clarification: 'clarification',
  quote_received: 'received',
  selected: 'selected',
  rejected: 'rejected',
};

export const VALID_TRANSITIONS = {
  draft: ['sent_to_vendor'],
  sent_to_vendor: ['vendor_clarification', 'quote_received'],
  vendor_clarification: ['sent_to_vendor', 'quote_received'],
  quote_received: ['selected', 'rejected'],
  selected: ['rejected'],
  rejected: ['selected'],
};

// Quotes that are actively "in progress" — useful for count badges and filters.
// Excludes 'selected' and 'rejected'.
export const IN_PROGRESS_STATUSES = new Set([
  'draft',
  'sent_to_vendor',
  'vendor_clarification',
  'quote_received',
]);

// Status options formatted for dropdowns/selects.
export const QUOTE_STATUS_OPTIONS = Object.entries(STATUS_LABELS).map(([value, label]) => ({
  value,
  label,
}));
